import api from './api';
import { 
  ReadingArticle, 
  ReadingAttempt, 
  SubmitAnswerRequest, 
  SubmitAnswerResponse, 
  ReadingStats,
  GenerateArticleRequest 
} from '../types';

export const readingService = {
  async generateArticle(data: GenerateArticleRequest): Promise<ReadingArticle> {
    const response = await api.post('/reading/generate', data);
    return response.data;
  },

  async getArticles(difficulty?: string, category?: string): Promise<ReadingArticle[]> {
    const params = new URLSearchParams();
    if (difficulty) params.append('difficulty', difficulty);
    if (category) params.append('category', category);
    
    const response = await api.get(`/reading/articles?${params.toString()}`);
    return response.data;
  },

  async getArticle(id: number): Promise<ReadingArticle> {
    const response = await api.get(`/reading/articles/${id}`);
    return response.data;
  },

  async startAttempt(articleId: number): Promise<ReadingAttempt> {
    const response = await api.post(`/reading/articles/${articleId}/start`);
    return response.data;
  },

  async submitAnswer(data: SubmitAnswerRequest): Promise<SubmitAnswerResponse> {
    const response = await api.post('/reading/submit-answer', data);
    return response.data;
  },

  async getStats(): Promise<ReadingStats> {
    const response = await api.get('/reading/stats');
    return response.data;
  },

  async deleteArticle(id: number): Promise<void> {
    await api.delete(`/reading/articles/${id}`);
  }
};
